import { BreakpointObserver, BreakpointState } from "@angular/cdk/layout";
import { CommonModule } from "@angular/common";
import { Component, Inject, OnInit, ViewChild } from "@angular/core";
import { Router } from "@angular/router";
import { TranslateModule } from "@ngx-translate/core";
import { Product, RoutePaths } from "@prequalification/models";
import {
  GA4View,
  GAPageMapping,
  PageEventDetails,
  ProductService,
  RbcTagManagerService,
  STEP_PAGES
} from "@prequalification/services";
import { SupportedLocale } from "@rig/common";
import { CTADirective } from "@rig/ng-buttons";
import { IconComponent } from "@rig/ng-media";
import { ModalComponent } from "@rig/ng-overlays";
import { BehaviorSubject, Observable, map } from "rxjs";
import { CREDIT_CARDS_BASE_URL } from "../../tokens/credit-cards-base-url.token";
import { PreQualificationComponent } from "../../components/pre-qualification/pre-qualification.component";

@Component({
  selector: "step-pre-qualification",
  templateUrl: "./step-pre-qualification.component.html",
  styleUrls: ["./step-pre-qualification.component.scss"],
  standalone: true,
  imports: [CommonModule, TranslateModule, CTADirective, IconComponent, PreQualificationComponent]
})
export class StepPreQualificationComponent implements OnInit {
  @ViewChild("cancelModal") cancelModal: ModalComponent | undefined;
  isMobile$ = new Observable<boolean>();
  product$: Observable<Product | undefined> = this.productService.product$;
  submitted$ = new BehaviorSubject<boolean>(false);
  lang: SupportedLocale;

   // TODO: Remove Later
  isAppEnabled = true; // CHANGE TO TRUE IF WANT NORMAL BEHAVIOUR

  constructor(
    private productService: ProductService,
    private router: Router,
    private gaService: RbcTagManagerService,
    private breakpointObserver: BreakpointObserver,
    @Inject(CREDIT_CARDS_BASE_URL) private creditCardsBaseUrl: string
  ) {
    this.lang = this.productService.lang as SupportedLocale;
  }

  ngOnInit(): void {
    this.isMobile$ = this.breakpointObserver.observe(["(max-width: 767px)"]).pipe(
      map((state: BreakpointState) => {
        return state.breakpoints["(max-width: 767px)"] ? true : false;
      })
    );

    setTimeout(() => this.sendGAEvent(), 1000);
  }

  sendGAEvent() {
    const cardType: string = this.productService.pid;

    const data: PageEventDetails = {
      pageName: STEP_PAGES.ELIGIBILITY,
      product: this.productService.chnl,
      cardType: cardType
    };

    const event: GA4View = {
      page_title: GAPageMapping[data.pageName].pageTitle
    };

    this.gaService.sendGtmPageView(event);
    this.gaService.sendGABeginCheckoutEvent(data);
  }


  continue() {
    this.router.navigate([RoutePaths.RIAM]);
  }

  back() {
    if (this.lang === 'en') {
      window.location.href = `${this.creditCardsBaseUrl}/business/credit-cards/index.html`;
    } else {
      window.location.href = `${this.creditCardsBaseUrl}/fr/entreprises/cartes-credit/index.html`;
    }
  }

  getProductName(product: Product): string {
    return this.productService.getProductName(product);
  }
}
